'use strict';

module.exports = '2.26.1';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch-helper/src/version.js
// module id = 338
// module chunks = 0